const sentryOptions = {
  dsn: 'https://d5a925d9f30e47b39b0cdf94ff45c4e0@sentry.io/1881061',
  // https://docs.sentry.io/platforms/javascript/configuration/sampling/#sampling-context-data
  tracesSampler: samplingContext => {
    if (samplingContext.transactionContext.name === '/_ping/') {
      return 0;
    }
    // Default sample rate
    return 0.1;
  },
  attachStacktrace: true,
};

export { sentryOptions };
